import Visible from '@portalterreno/react-ui/Visible';
import { useTranslation } from 'next-i18next';
import React from 'react';

import slugify from '../../../../utils/slugify';
import CampaignDiscountChip from '../../../Campaign/CampaignDiscountChip';
import ShareButtonDesktop from '../ShareButton/ShareButtonDesktop';
import Location, { LocationProps } from './Location';
import Logo from './Logo';
import StyledInfoDiv from './StyledInfoDiv';
import StyledPropertyTitleDiv from './StyledPropertyTitleDiv';
import StyledPropertyTitleLocationDiv from './StyledPropertyTitleLocationDiv';
import StyledTitle from './StyledTitle';
import StyledWrapper from './StyledWrapper';

export type PropertyTitleProps = {
  title: string;
  campaignChipText?: string;
  logo?: string;
  urlOperation?: LocationProps['urlOperation'];
  urlPropertyType?: LocationProps['urlPropertyType'];
} & Omit<
  LocationProps,
  'city' | 'commune' | 'urlOperation' | 'urlPropertyType'
>;

const PropertyTitle: React.FC<PropertyTitleProps> = ({
  title,
  regionName,
  cityName,
  cityId,
  citySlug,
  communeId,
  communeName,
  communeSlug,
  campaignChipText,
  logo,
  urlOperation,
  urlPropertyType,
  ...rest
}) => {
  const { t } = useTranslation('property');
  const commune = slugify(t('commune'));
  const city = slugify(t('city'));

  if (!urlOperation) {
    urlOperation = 'venta';
  }

  if (!urlPropertyType) {
    urlPropertyType = 'terreno';
  }

  return (
    <StyledWrapper
      logo={logo}
      {...rest}
    >
      <StyledInfoDiv>
        <StyledPropertyTitleDiv>
          {logo && <Logo image={logo} />}
          <StyledPropertyTitleLocationDiv>
            <StyledTitle
              variant='title'
              weight='medium'
            >
              {title}
            </StyledTitle>
            <Location
              city={city}
              cityId={cityId}
              cityName={cityName}
              citySlug={citySlug}
              commune={commune}
              communeId={communeId}
              communeName={communeName}
              communeSlug={communeSlug}
              regionName={regionName}
              urlOperation={urlOperation}
              urlPropertyType={urlPropertyType}
            />
          </StyledPropertyTitleLocationDiv>
          {campaignChipText && (
            <div>
              <CampaignDiscountChip campaignChipText={campaignChipText} />
            </div>
          )}
        </StyledPropertyTitleDiv>
        <Visible desktop>
          <ShareButtonDesktop />
        </Visible>
      </StyledInfoDiv>
    </StyledWrapper>
  );
};

export default React.memo(PropertyTitle);
